import axios from 'axios';
import { PressData } from '../models/listpress';
const API_URL = process.env.REACT_APP_API_URL;
const CODECLIENT = process.env.REACT_APP_CODE_CLIENT;
const SHAI = process.env.REACT_APP_SHAI;

const sendSoapRequest = async (
  texteAnnonce: string,
  nType: number,
  nStype: number,
  departementCode: string,
  postalCode?: string
): Promise<PressData[]> => {
  try {
    const headers = {
      "Content-Type": "application/json",
      // 'Authorization': 'Bearer YOUR_TOKEN', // Remplace par le token approprié
      // Ajoute d'autres en-têtes si nécessaire
    };
    // console.log("TEXT ANNONCE",texteAnnonce);

    const body = {
      sSHA1: SHAI,
      codeClient: CODECLIENT,
      habilitation: 0,
      texteAnnonce,
      departement: departementCode,
      nStype,
      nType,
      nJustif: 1,
      demande: "",
      entete: "",
      floId: 0,
      postalCode,
    };

    const response = await axios.post(`${API_URL}/annonce/presse`, body, {
      headers,
    });

    // console.log(response.data);
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(response.data, "text/xml");

    // Extract the data
    const tabJal = xmlDoc.getElementsByTagName("tabJal_prix");
    const data: PressData[] = Array.from(tabJal).map((jal) => ({
      support: jal.getElementsByTagName("sName_Jal")[0]?.textContent || "",
      id: jal.getElementsByTagName("sId_Jal")[0]?.textContent || "",
      departement: jal.getElementsByTagName("sDep")[0]?.textContent || "",
      publication: jal.getElementsByTagName("sDParution")[0]?.textContent || "",
      diffusion: jal.getElementsByTagName("sTypePresse")[0]?.textContent || "",
      prixHT: jal.getElementsByTagName("moTHT")[0]?.textContent || "",
      prixTTC: jal.getElementsByTagName("moTTC")[0]?.textContent || "",
      pref: jal.getElementsByTagName("nJalPref")[0]?.textContent || "",
    }));

    return data;
  } catch (error) {
    console.error("Erreur lors de la récupération des logos:", error);
    throw error;
  }
};

export default sendSoapRequest;
